import { FIELD_MAPPINGS } from './constants';

export default Object.keys(FIELD_MAPPINGS);
